import { isBusinessHours } from '~/helpers/time'

const whatsappUrl = 'https://api.whatsapp.com/send?'
const phone = '5511988259772'

export const generateWhatsAppLink = (
  urlParams: Record<string, string>,
): string => {
  const isCxPhone = !urlParams.phone
  const redirectToCX = isBusinessHours()

  if (isCxPhone && !redirectToCX) {
    return `${location.origin}/atendimento-indisponivel`
  }

  if (Object.keys(urlParams).length > 0) {
    return `${whatsappUrl}${Object.entries({ phone, ...urlParams })
      .map(([k, v]) => `&${encodeURI(k)}=${encodeURI(v)}`)
      .reduce((c, n) => c + n)}`
  }

  return whatsappUrl
}
